// One connected account, drawn small.
//
// The picture and the name came from the network when the account was
// connected, and they are the only things on any of these surfaces that did:
// nothing here is a follower count, a reach figure or anything else read back
// from Facebook, Instagram or YouTube. The platform mark rides on the corner
// so an account is identifiable at 28px, where a name cannot be shown at all.
//
// No picture, or a picture that will not load: the account's first letter, on
// the disc whose colour is derived from its name. One letter and not two — the
// rail's disc is 30px and a second letter is a smudge — and never a question
// mark about an account somebody connected themselves.

import { useState } from "react";
import { Monogram } from "./Monogram";
import { PLATFORM_ICON } from "./PlatformIcons";
import { PLATFORM_LABEL, type Connection } from "../lib/types";

export function AccountMark({
  connection, size = "sm",
}: {
  connection: Connection;
  size?: "sm" | "md";
}) {
  const Icon = PLATFORM_ICON[connection.platform];
  // A network's CDN URL outlives neither the account nor our copy of it, and a
  // broken-image glyph is worse than no picture at all.
  const [broken, setBroken] = useState(false);

  return (
    <span className={`acct-mark acct-mark-${size}`}>
      {connection.avatar_url && !broken
        ? <img src={connection.avatar_url} alt="" className="acct-face" loading="lazy"
               onError={() => setBroken(true)} />
        : <Monogram label={connection.display_name} className="acct-face" max={1} />}
      <span className="acct-platform">
        <Icon className="platform-icon" />
      </span>
    </span>
  );
}

/** "Instagram — @simino.social", the one string every tooltip and label uses. */
export const accountLabel = (c: Connection) =>
  `${PLATFORM_LABEL[c.platform]} — ${c.display_name}`;
